// extracted by mini-css-extract-plugin
export default {"container":"Popup_container__y+8eL","arrow":"Popup_arrow__Jsym1"};